import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { PageViewApiService } from "@core/api/v1";
import { FaqEntryVO } from "@core/api/v1/model/faqEntryVO";
import { MessageService } from "primeng/api";

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss'
})
export class FaqComponent implements OnInit{
    faqEntries: FaqEntryVO[] = [];
    nav: SafeHtml;
    questions: SafeHtml;

    constructor(private api: PageViewApiService, private messageService: MessageService, private sanitizer: DomSanitizer) {}

    ngOnInit() {
        this.api.getFaqEntries().subscribe(result => {
            this.faqEntries = result;
            this.navBuilder();
            this.questionsBuilder();
        }, error => {this.showError(error)});
    }

    navBuilder() {
        let navText: string;
        navText = '<ol>'
        this.faqEntries.forEach((faqEntry, index) => {
            navText += '<li><a href="/faq#' + (index + 1) + '" style="color: #4782b2;">' + faqEntry.frage + '</a></li>'
        })
        navText += '</ol>';
        this.nav = this.sanitizer.bypassSecurityTrustHtml(navText);
    }

    questionsBuilder() {
        let questionsText: string = '';
        this.faqEntries.forEach((faqEntry, index) => {
            questionsText += '<p><span id="' + (index + 1) + '" style="color: #4782b2;">' +
                '<i class="pi pi-angle-double-right" style="font-size: 13px;"></i> ' + (index + 1) + '. <strong>' +  faqEntry.frage
                + '</strong></span></p><p>' + faqEntry.antwort + '</p>';
        })
        this.questions = this.sanitizer.bypassSecurityTrustHtml(questionsText);
    }

    showError(error: any) {
        this.messageService.add({severity: 'error', summary: 'Fehler beim speichern', detail: JSON.parse(error.error).message});
    }
}
